import React from 'react';
import * as styles from './navigation-decorators.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var outerClass = 'fe-co-allhomes-hero-photo-preview';
/* eslint-disable react/prop-types */

var navigationDecorators = _ref => {
  var onNavigationArrowClicked = _ref.onNavigationArrowClicked;
  return [{
    component: props => ___EmotionJSX("button", {
      "aria-controls": "hero-carousel",
      "aria-label": "Previous Photo",
      css: styles.navigation({
        isLeft: true
      }),
      onClick: () => {
        onNavigationArrowClicked('left');
        props.previousSlide();
      },
      type: "button"
    }, ___EmotionJSX("svg", {
      css: styles.navigationIcon({
        isLeft: true
      }),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 42"
    }, ___EmotionJSX("path", {
      d: "M20 4L4 20 20 36"
    })), ___EmotionJSX("div", {
      css: styles.gradient({
        isLeft: true
      }),
      className: "".concat(outerClass, "__gradient is-left")
    }), ___EmotionJSX("div", {
      css: styles.gradientHover({
        isLeft: true
      }),
      className: "".concat(outerClass, "__gradient-hover is-left")
    })),
    position: 'CenterLeft'
  }, {
    component: props => ___EmotionJSX("button", {
      "aria-controls": "hero-carousel",
      "aria-label": "Next Photo",
      css: styles.navigation({
        isRight: true
      }),
      onClick: () => {
        onNavigationArrowClicked('right');
        props.nextSlide();
      },
      type: "button"
    }, ___EmotionJSX("svg", {
      css: styles.navigationIcon({
        isRight: true
      }),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 42"
    }, ___EmotionJSX("path", {
      d: "M4 4L20 20 4 36"
    })), ___EmotionJSX("div", {
      css: styles.gradient({
        isRight: true
      }),
      className: "".concat(outerClass, "__gradient is-right")
    }), ___EmotionJSX("div", {
      css: styles.gradientHover({
        isRight: true
      }),
      className: "".concat(outerClass, "__gradient-hover is-right")
    })),
    position: 'CenterRight'
  }];
};
export default navigationDecorators;